import ReactDOM from 'react-dom/client';
import React from 'react';
import DemoPixelMap from './Demo';

export default function PixelMap() {
	const root = ReactDOM.createRoot(document.getElementById('root'));
	root.render(<DemoPixelMap/>);
}
